/*
 *
 * DisableVasPopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 19-May-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import MerchantModal from '@nexidigital/merchantmodal'
import history from 'Utility/history'
import useManageVasForm from 'Hooks/useManageVasForm'
import { routesList } from 'Schemas/routesList'
import ServiceConfig from '../ServiceConfig'
import { messages } from './languageModule'

const DisableVasPopup = ({ actions, isLoading, featureName }) => {
  const intl = useIntl()
  const formik = useManageVasForm({
    initialValues: {
      status: 'Enabled',
      ...(featureName === 'Disputeless' ? { termsAccepted: true } : {})
    },
    onSubmit: (values) => {
      if (featureName === 'Disputeless') {
        actions.doSetDisputelessStatus({ status: values.status })
      } else {
        actions.doUpdateVas({ status: values.status }, () =>
          history.replace(routesList.terminalsManagement.goToTerminalsManagement)
        )
      }
    }
  })
  return (
    <MerchantModal
      onClose={() => actions.closePopup()}
      primaryAction={() => formik.submitForm()}
      primaryButtonDisabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
      primaryButtonLoading={isLoading}
      closeLabel={intl.formatMessage(messages.close)}
      primaryButtonLabel={intl.formatMessage(messages.confirm)}>
      <ServiceConfig
        title={intl.formatMessage(messages.deactivationTitle)}
        description={intl.formatMessage(messages[`description_${featureName}`])}
        active={formik.values.status === 'Enabled'}
        onSwitchChange={(selectedOption) => {
          formik.setFieldValue('status', selectedOption ? 'Enabled' : 'Disabled')
        }}
        disabled={featureName === 'Disputeless'}
        checked={formik.values.termsAccepted}
        onCheckChange={
          featureName === 'Disputeless'
            ? (selectedOption) => formik.setFieldValue('termsAccepted', selectedOption)
            : null
        }
      />
    </MerchantModal>
  )
}

DisableVasPopup.propTypes = {
  actions: PropTypes.object,
  isLoading: PropTypes.bool,
  featureName: PropTypes.string
}

DisableVasPopup.defaultProps = {
  actions: {},
  isLoading: false
}

export default DisableVasPopup
